import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import PropTypes from 'prop-types';

import EmptyTab from "../reports/EmptyTab";

import forwardarrow from '../../assets/forwardarrow.png';
import backwardarrow from '../../assets/backarrow.png';
import interviewer from '../../assets/interviewguide.jpeg';
import reportarrow from '../../assets/reportarrow.svg';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../../styles/interviewerGuide.scss';
import { roleWf } from '../../constants/reports';
import { getJobRole } from '../../utils/reports';

const InterviewerGuide = (props) => {
	const { productId, reportWorkFunctions } = props;

	let jobRole;
	if(productId) jobRole = getJobRole(productId);

	if(!jobRole) return <EmptyTab text={"Couldn't find interview guide for this assessment"} />
	return (
		<div className='carousel-container'>
			<OwlCarousel
				className='owl-theme'
				loop
				nav
				items={1}
				navText={[`<div class='nav-button owl-prev'><img src=${backwardarrow}></div>`, `<a class='owl-next nav-button'><img src=${forwardarrow}></a>`]}
			>
				<div className="item interview-box">
					<h3 className='title'>INTERVIEWER&apos;S GUIDE</h3>
					<div className='content-box'>
						<div style={{ flex: "1", margin: "20px 0", boxSizing: "border-box" }}>
							<div>
								<p style={{ color: "#8F8F92", fontWeight: "500", fontSize: "14px" }}>
									Our assessment is built on the principle of testing how well candidates are able to
									perform critical work functions associated with the role. This enables us to observe
									directly how they are likely to perform in the job, as well as to identify strengths
									and gaps in their functional skills (role-specific capabilities) and core skills
									(general capabilities). Swipe right to view more details on the critical work functions,
									their associated tasks, and the underlying skills.
								</p>
							</div>
						</div>
						<div className='img-box'>
							<img src={interviewer} alt="" style={{ maxWidth: "180px" }} />
						</div>
					</div>
					<div>
						<p className='note-box'>
							Note:  These classifications are based on the Skills Framework created by Skillsfuture Singapore.
							For more information, please visit&nbsp;
							<a href="https://www.skillsfuture.gov.sg/skills-framework" target='_blank' rel='noreferrer'>https://www.skillsfuture.gov.sg/skills-framework</a>
						</p>
					</div>
				</div>

				{
					roleWf[jobRole].map((item, index) => {
						if (Object.prototype.hasOwnProperty.call(reportWorkFunctions[item], "typicalTasks")) {
							return (
								<div key={index} className="item main-slide-box">
									<h3 style={{ padding: "0 20px", color: '#4A4A4A' }}>{reportWorkFunctions[item].label}</h3>
									<div className='second-carousel-box'>
										<div className='content-box'>
											<div className='heading'>
												<span style={{ background: "#E4E4E4", padding: "10px", borderRadius: "10px", fontWeight: "700", color: "#707070", marginLeft: "25px" }}>Typical task</span>
											</div>
											<div style={{ marginTop: "30px" }}>
												{
													reportWorkFunctions[item].typicalTasks.map((tt) => (
														<div key={tt} style={{ display: "flex", margin: "10px 0" }}>
															<div style={{ marginRight: "15px", color: "#479BD2", marginTop: "5px" }}>
																<img style={{ width: "12px", height: "12px" }} src={reportarrow} alt='' />
															</div>
															<p style={{ fontSize: "12px" }}>{tt}</p>
														</div>
													))
												}
											</div>
										</div>
										<div className='thin-border'>&nbsp;</div>
										<div className='content-box'>
											<div className='heading'>
												<span style={{ background: "#E4E4E4", padding: "10px", borderRadius: "10px", fontWeight: "700", color: "#707070", marginLeft: "25px" }}>Associated skills</span>
											</div>
											<div style={{ marginTop: "30px" }}>
												{
													reportWorkFunctions[item].associatedSkills.map((as, j) => (
														<div key={j} style={{ display: "flex", margin: "10px 0" }}>
															<div style={{ marginRight: "15px", color: "#479BD2", marginTop: "5px" }}><img style={{ width: "12px", height: "12px" }} src={reportarrow} alt='' /></div>
															<p style={{ fontSize: "12px" }}><span style={{ fontWeight: "700" }}>{as.title}: </span>{as.detail}</p>
														</div>
													))
												}
											</div>
										</div>
									</div>
								</div>
							)
						} else if (Object.prototype.hasOwnProperty.call(reportWorkFunctions[item], "relevantQuestions")){
							return (
								<div key={index} className="item main-slide-box">
									<h3 style={{ padding: "0 20px", textAlign: 'center', color: '#4A4A4A' }}>{reportWorkFunctions[item].label}</h3>
									<div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
										<div style={{ width: "47%", margin: "20px 0", boxSizing: "border-box" }}>
											<div>
												<span style={{ background: "#E4E4E4", padding: "10px", borderRadius: "10px", fontWeight: "700", color: "#707070", marginLeft: "25px" }}>Description</span>
											</div>
											<div style={{ marginTop: "30px" }}>
												<p style={{ fontSize: "12px" }}>{reportWorkFunctions[item].description}</p>
											</div>
										</div>
										<div style={{ width: "2px", background: "#E4E4E4", margin: "20px 0" }}>&nbsp;</div>
										<div style={{ width: "47%", margin: "20px 0", boxSizing: "border-box" }}>
											<div>
												<span style={{ background: "#E4E4E4", padding: "10px", borderRadius: "10px", fontWeight: "700", color: "#707070", marginLeft: "25px" }}>Relevant Questions</span>
											</div>
											<div style={{ marginTop: "30px" }}>
												{
													reportWorkFunctions[item].relevantQuestions.map((rq) => (
														<div key={rq} style={{ display: "flex", margin: "10px 0" }}>
															<div style={{ marginRight: "15px", color: "#479BD2", marginTop: "5px" }}><img style={{ width: "12px", height: "12px" }} src={reportarrow} alt='' /></div>
															<p style={{ fontSize: "12px" }}>{rq}</p>
														</div>
													))
												}
											</div>
										</div>
									</div>
								</div>

							);
						} else{
							return ''
						}
					})
				}
			</OwlCarousel>
		</div>
	)
}

InterviewerGuide.propTypes = {
	productId: PropTypes.object,
	reportWorkFunctions: PropTypes.object
}

export default InterviewerGuide;
